import { DocumentNode } from "@apollo/client";
import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { ApiKeyUpdateInput } from "types/generated";
import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { UPDATE_API_KEY } from "./gql";

type UseUpdateApiKeyProps = {
  apiKeyId: string;
  callback?: () => void;
  refetchQueries?: DocumentNode[];
};

const useUpdateApiKeyMutation = createDefaultMutationHook(UPDATE_API_KEY);

export const useUpdateApiKey = ({ apiKeyId, callback, refetchQueries }: UseUpdateApiKeyProps) => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [updateApiKey, { loading }] = useUpdateApiKeyMutation({
    refetchQueries,
    awaitRefetchQueries: true,
  });

  const onUpdate = useCallback(
    (input: ApiKeyUpdateInput) => {
      updateApiKey(
        {
          id: apiKeyId,
          input,
        },
        (data) => {
          if (data?.apiKeyUpdate) {
            reportSuccess({
              message: "API key updated successfully",
            });
            callback?.();
          }
        }
      );
    },
    [apiKeyId, callback, reportSuccess, updateApiKey]
  );

  return {
    onUpdate,
    loading,
  };
};
